import { useSearchParams } from "react-router";
import { listCollection } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import FilterChips from "../components/FilterChips/FilterChips.jsx";
import EntryGrid from "../components/EntryGrid/EntryGrid.jsx";
import CTABand from "../components/CTABand/CTABand.jsx";

const PAGE = {
  title: "Projects",
  description:
    "A portfolio of 3D visualization and road safety projects for state DOTs, cities and engineering firms.",
  path: "/projects",
};
const OPTIONS = [
  { value: "all", label: "All" },
  { value: "rsa3d", label: "Road Safety Audit 3D" },
  { value: "123bim", label: "3D Visualization" },
];

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  return { items: listCollection("projects") };
}

export default function Projects({ loaderData }) {
  const [params, setParams] = useSearchParams();
  const product = OPTIONS.some((o) => o.value === params.get("product"))
    ? params.get("product")
    : "all";
  const items = loaderData.items.filter(
    (e) => product === "all" || e.product === product || e.product === "both"
  );
  return (
    <>
      <PageHero
        eyebrow="Our work"
        title="Projects"
        lead={PAGE.description}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Projects", path: PAGE.path },
        ]}
      />
      <section className="section">
        <div className="container">
          <FilterChips
            label="Filter by product"
            options={OPTIONS}
            value={product}
            onChange={(v) => setParams(v === "all" ? {} : { product: v }, { replace: true })}
          />
          <EntryGrid
            items={items}
            kind="project"
            hrefFor={(e) => `/projects/${e.slug}`}
            metaFor={(e) => [e.client, e.year].filter(Boolean).join(" · ")}
          />
        </div>
      </section>
      <CTABand title="Add your project to the list" />
    </>
  );
}
